import { HttpParams } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, MessageService, PrimeNGConfig, SelectItem } from 'primeng/api';
import { Observable, catchError, finalize, observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AccounDataDTO, ProductDTO, ProductService, OrderService, OrderDTO, OrderItemDTO, LookUpService, CustomerService, ClientDTO, BranchDTO, CustomerDTO } from 'synergy-core';
declare var $: any;

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.css']
})
export class OrdersComponent {
  layout: string = 'list';
  products!: ProductDTO[];
  currentUser!: AccounDataDTO;
  sortOptions!: SelectItem[];
  filteredData!: any[];
  organizationId!: number;
  selectedId!: string;
  sortOrder!: number;
  buttonDisabled!: boolean;
  sortField!: string;
  sortKey!: any;
  cols!: any[];
  detail!: OrderItemDTO[];
  data!: OrderDTO[];
  subtotal: number = 0;
  taxes: number = 0;
  discounts: number = 0;
  total: number = 0;
  order!: OrderDTO;
  orderNumber!: string;
  documentKey!: string;
  loading: boolean = false;
  submitted: boolean = false;
  itemsCount: number = 0;
  showClientDialog: boolean = false;


  masterClientForm!: FormGroup;
  personTypes!: any[];
  countries!: any[];
  states!: any[];
  cities!: any[];
  districts!: any[];
  nighboorhoods!: any[];
  clientData!: BranchDTO[];
  clientSubmitted: boolean = false;
  selectedClientId!: string;
  filteredClientData!: any[];
  clientName: string = "";

  constructor(private productService: ProductService,
    private messageService: MessageService,
    private orderService: OrderService,
    private confirmationService: ConfirmationService,
    private lookupDataService: LookUpService,
    private customerService: CustomerService,
    private primengConfig: PrimeNGConfig) {
  }

  collap() {
    $('.example-collapse').collapse('toggle');
  }



  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    let httpParams = new HttpParams().set('clientId', this.currentUser.ClientId);
    this.productService.Get(httpParams).subscribe(val => {
      this.products = val.Data;
    });

    this.sortOptions = [
      { label: 'Descendente', value: '!SortOrder' },
      { label: 'Ascendente', value: 'SortOrder' }
    ];

    this.setDetail();
    this.getActiveOrders();
    this.getPersonTypes();
    this.getCountries();
    this.getClientData();
    this.setClientForm();
    this.primengConfig.ripple = true;
  }


  //CLIENTE SECTION//
  onAddClient() {
    this.showClientDialog = true;
  }

  getPersonTypes() {
    this.lookupDataService.getPersonTypes().subscribe(data => {
      if (data) {
        this.personTypes = data;
      }
    });
  }

  getCountries() {
    this.lookupDataService.GetCountries().subscribe(val => {
      this.countries = val.Data;
    });
  }

  onAddNewClient() {
    this.masterClientForm.reset({ id: '00000000-0000-0000-0000-000000000000', phoneNumber1: "(506)", phoneNumber2: "(506)", isActive: true });
  }

  getClientData() {
    const httpParams = new HttpParams().set('clientId', this.currentUser.ClientId);
    this.customerService.Get(httpParams).subscribe(val => {
      this.clientData = val.Data;
    });
  }

  setClientForm() {
    this.masterClientForm = new FormGroup({
      id: new FormControl('00000000-0000-0000-0000-000000000000',),
      name: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
      lastName: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
      email: new FormControl(null, [Validators.required, Validators.email]),
      phoneNumber1: new FormControl("(506)", [Validators.required]),
      phoneNumber2: new FormControl("(506)"),
      countryId: new FormControl(null, [Validators.required]),
      stateId: new FormControl(null, [Validators.required]),
      cityId: new FormControl(null, [Validators.required]),
      districtId: new FormControl(null, [Validators.required]),
      neighborhoodId: new FormControl(null),
      identification: new FormControl(null, [Validators.required]),
      personTypeId: new FormControl(null, [Validators.required]),
      address: new FormControl(null, [Validators.required, Validators.maxLength(500)]),
      detail: new FormControl(null, [Validators.maxLength(500)]),
      isActive: new FormControl(true),
    });
  }

  onClientCancel() {
    this.masterClientForm.reset({ phoneNumber1: "(506)", phoneNumber2: "(506)", isActive: true });
    this.showClientDialog = false;
  }

  onSubmitClient() {
    this.clientSubmitted = true;

    if (this.masterClientForm.invalid) {
      return;
    }

    this.loading = true;
    let dto = new CustomerDTO();
    dto.ClientId = this.currentUser.ClientId;
    dto.Id = this.masterClientForm.value.id;
    dto.ApplicationId = environment.applicayionId;
    dto.Name = this.masterClientForm.value.name;
    dto.LastName = this.masterClientForm.value.lastName;
    dto.EmailAddress = this.masterClientForm.value.email;
    dto.PhoneNumber1 = this.masterClientForm.value.phoneNumber1;
    dto.PhoneNumber2 = this.masterClientForm.value.phoneNumber2;
    dto.CountryId = this.masterClientForm.value.countryId;
    dto.StateId = this.masterClientForm.value.stateId;
    dto.CityId = this.masterClientForm.value.cityId;
    dto.DistrictId = this.masterClientForm.value.districtId;
    dto.NeighborhoodId = this.masterClientForm.value.neighborhoodId;
    dto.Address = this.masterClientForm.value.address;
    dto.Detail = this.masterClientForm.value.detail;
    dto.IsActive = this.masterClientForm.value.isActive;
    dto.PersonTypeId = this.masterClientForm.value.personTypeId;
    dto.Identification = this.masterClientForm.value.identification;
    dto.CreatedBy = this.currentUser.Id;
    dto.CreatedDate = new Date();
    dto.ModifiedBy = this.currentUser.Id;
    dto.ModifiedDate = new Date();
    this.customerService.Create(dto).pipe(
      finalize(() => {
        this.loading = false;
        this.clientSubmitted = false;
        this.buttonDisabled = false;
      }),
      catchError((error) => {
        throw error;
      })).subscribe((data) => {
        if (data.Success) {
          
          if(this.masterClientForm.value.name != null){
            this.clientName +=  this.masterClientForm.value.name; 
          }
          if(this.masterClientForm.value.lastName != null){
            this.clientName += ' ' +  this.masterClientForm.value.lastName; 
          }

          this.messageService.add({ key: 'tc', severity: 'info', summary: 'Proceso completado exitosamente', detail: 'Se ha creado el nuevo cliente.' });
          this.masterClientForm.reset({ phoneNumber1: "(506)", phoneNumber2: "(506)", isActive: true });         
          this.showClientDialog = false;
          this.getClientData();
        } else {
          this.messageService.add({ key: 'tc', severity: 'error', summary: "Se ha producido un error", detail: data.Message });
        }
      });
  }

  onSelectCountry(id: number) {
    this.lookupDataService.GetStatesByCountryId(id).subscribe(data => {
      if (data) {
        this.states = data.Data;
      }
    });
  }

  onSelectState(id: number) {
    this.lookupDataService.GetCityByStateId(id).subscribe(data => {
      if (data) {
        this.cities = data.Data;
      }
    });
  }

  onSelectCity(id: number) {
    this.lookupDataService.GetDistrictByCityId(id).subscribe(data => {
      if (data) {
        this.districts = data.Data;
      }
    });
  }

  onSelectDistrict(id: number) {
    this.lookupDataService.GetNeighborhoodByDistrictId(id).subscribe(data => {
      if (data) {
        this.nighboorhoods = data.Data;
      }
    });
  }

  onClientFilter(event: any) {
    let query = event.query;
    this.filteredClientData = this.filterClientData(query);
  }

  filterClientData(query: any): any[] {
    let filtered: any[] = [];
    for (let i = 0; i < this.clientData.length; i++) {
      let current = this.clientData[i];
      if (current.Name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(current);
      }
    }
    return filtered;
  }

  onClientSelect(event: any) {
    this.getClientById(event.Id);
  }

  getClientById(id: string) {
    const httpParams = new HttpParams().set('clientId', this.currentUser.ClientId)
      .set('id', id);

    this.customerService.GetById(httpParams).subscribe(val => {
      let customer = val.Data[0];

      setTimeout(() => {
        this.onSelectCountry(customer.CountryId);
      }, 50);
      setTimeout(() => {
        this.onSelectState(customer.StateId);
      }, 50);
      setTimeout(() => {
        this.onSelectCity(customer.CityId);
      }, 50);
      setTimeout(() => {
        this.onSelectDistrict(customer.DistrictId);
      }, 50);

      setTimeout(() => {
        this.masterClientForm.controls["countryId"].setValue(customer.CountryId);
        this.masterClientForm.controls["stateId"].setValue(customer.StateId);
        this.masterClientForm.controls["cityId"].setValue(customer.CityId);
        this.masterClientForm.controls["districtId"].setValue(customer.DistrictId);
        this.masterClientForm.controls["neighborhoodId"].setValue(customer.NeighborhoodId);
        this.masterClientForm.controls["id"].setValue(customer.Id);
        this.masterClientForm.controls["name"].setValue(customer.Name);
        this.masterClientForm.controls["email"].setValue(customer.EmailAddress);
        this.masterClientForm.controls["lastName"].setValue(customer.LastName);
        this.masterClientForm.controls["personTypeId"].setValue(customer.PersonTypeId);
        this.masterClientForm.controls["identification"].setValue(customer.Identification);
        this.masterClientForm.controls["phoneNumber1"].setValue(customer.PhoneNumber1);
        this.masterClientForm.controls["phoneNumber2"].setValue(customer.PhoneNumber2);
        this.masterClientForm.controls["address"].setValue(customer.Address);
        this.masterClientForm.controls["detail"].setValue(customer.Detail);
        this.masterClientForm.controls["isActive"].setValue(customer.IsActive);
      }, 50);
    });
  }

  onAddClientToOrder() {
    
    if(this.masterClientForm.value.name != null){
      this.clientName +=  this.masterClientForm.value.name; 
    }
    if(this.masterClientForm.value.lastName != null){
      this.clientName += ' ' +  this.masterClientForm.value.lastName; 
    }

    this.showClientDialog = false;
  }

  get masterControls() {
    return this.masterClientForm.controls;
  }






  getActiveOrders() {
    let httpParams = new HttpParams().set('searchCriteria', ' A.[OrderStatusId] = 0 AND A.[ClientId] = \'' + this.currentUser.ClientId + '\'');

    this.orderService.GetOrders(httpParams).subscribe(val => {
      this.data = val.Data;
    });
  }

  setDetail() {
    this.cols = [
      { field: 'Line', header: '#', visible: true },
      { field: 'Name', header: 'Detalle', visible: true },
      { field: 'Quantity', header: 'Cant.', visible: true },
      { field: 'Price', header: 'Precio.', visible: true },
    ];
  }

  onSortChange($event: any) {
    let value = $event.value;

    if (value.indexOf('!') === 0) {
      this.sortOrder = -1;
      this.sortField = value.substring(1, value.length);
    }
    else {
      this.sortOrder = 1;
      this.sortField = value;
    }
  }

  onAddNew(product?: any) {

    this.loading = true;
    let httpParams = new HttpParams().set('clientId', this.currentUser.ClientId)
      .set('userId', this.currentUser.Id)
      .set('applicationId', environment.applicayionId)
      .set('branchCode', 1)
      .set('orderType', 4)
      .set('posId', 1);

    this.orderService.GetNewOrder(httpParams).pipe(
      finalize(() => {
        this.loading = false;
        this.submitted = false;
      }),
      catchError((error) => {
        throw error;
      })).subscribe((data) => {
        if (data.Success) {
          this.order = data.Data[0];
          this.documentKey = this.order.DocumentKey;
          this.orderNumber = this.order.OrderNumber.toString().padStart(9, "0");
          this.addDetail(product);
        } else {
          this.messageService.add({ key: 'tc', severity: 'error', summary: "Se ha producido un error", detail: data.Message });
        }
      });
  }

  onFilter(event: any) {
    let query = event.query;
    this.filteredData = this.filterData(query);
  }

  filterData(query: any): any[] {
    let filtered: any[] = [];
    for (let i = 0; i < this.data.length; i++) {
      let current = this.data[i];
      if (current.OrderNumber.toString().toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(current);
      }
    }
    return filtered;
  }

  addDetail(product: ProductDTO) {

    console.log(product);
    this.loading = true;
    let item = new OrderItemDTO();
    item.ApplicationId = environment.applicayionId;
    item.ClientId = this.currentUser.ClientId;
    item.CreatedBy = this.currentUser.Id;
    item.CreatedDate = new Date;
    item.Detail = product?.Name;
    item.DetailId = 1;
    item.Discount = 0;
    item.DiscountAmount = 0;
    item.DiscountDetail = '';
    item.DiscountId = '';
    item.GrossTotalAmount = 0;
    item.Id = '';
    item.IsActive = true;
    item.Name = product.Name;
    item.Quantity = 1;
    item.SKU = product?.SKU;
    item.OrderId = this.order?.Id;
    item.ParentDetailId = 0;
    item.Price = product.Price;
    item.ProductId = product?.Id;
    item.ProductTypeId = product?.ProductTypeId;
    item.SubTotalAmount = 0;
    item.Tax = product.TaxPercentage!;
    item.TaxAmount = item.Price / 100 * item.Tax;
    item.TaxDetail = product?.TaxName;
    item.TotalAmount = 0;
    item.IsBundle = product.IsBundle;
    

    this.orderService.AddDetail(item).pipe(
      finalize(() => {
        this.submitted = false;
      }),
      catchError((error) => {
        throw error;
      })).subscribe((data) => {
        if (data.Success) {
          let httpParams = new HttpParams().set('clientId', this.currentUser.ClientId)
            .set('id', this.order.Id);
          this.orderService.GetById(httpParams).subscribe(val => {
            this.subtotal = val.Data[0].SubTotalAmount;
            this.taxes = val.Data[0].TaxAmount;
            this.discounts = val.Data[0].DiscountAmount;
            this.total = val.Data[0].TotalAmount;
            this.detail = val.Data[0].OrderItems;
            this.itemsCount = val.Data[0].ItemsCount;
          });
        } else {
          this.messageService.add({ key: 'tc', severity: 'error', summary: "Se ha producido un error", detail: data.Message });
        }
        this.loading = false;
      });


  }

  addProduct(product: ProductDTO) {

    if (this.order == null) {
      product.TaxPercentage = 13;
      this.onAddNew(product);
    } else {
      this.addDetail(product);
    }
  }

  onSelect($event: any) {
    //this.getActiveOrders();
  }

  getSeverity(product: string) {
    /*  switch (product) {
          case 'INSTOCK':
              return 'success';

          case 'LOWSTOCK':
              return 'warning';

          case 'OUTOFSTOCK':*/
    return 'danger';

    /* default:
         return null;
 }
};*/
  }

  onCancelOrder() {
    let httpParams = new HttpParams().set('clientId', this.currentUser.ClientId)
      .set('orderId', this.order.Id.toString())
      .set('userId', this.currentUser.Id);

    this.confirmationService.confirm({
      message: 'Desea realmente cancelar la orden?',
      header: 'Confirmacion',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.loading = true;
        this.orderService.Cancel(httpParams).pipe(
          finalize(() => {
           
          }),
          catchError((error) => {
            throw error;
          })).subscribe((data) => {
            if (data.Success) {
              this.messageService.add({ key: 'tc', severity: 'info', summary: 'Proceso completado exitosamente', detail: 'Se ha eliminado el descuento.' });
              this.order = new OrderDTO();
              this.detail = [];
              this.subtotal = 0;
              this.taxes = 0;
              this.discounts = 0;
              this.total = 0;
              this.itemsCount = 0;
              this.orderNumber = '';
              this.documentKey = '';
            } else {
              this.messageService.add({ key: 'tc', severity: 'error', summary: "Se ha producido un error", detail: data.Message });
            }

            this.loading = false;
          });
      },
      reject: () => {
      }
    });
  }
}